<template>
  <div :class="$style.wrapper">
    <!-- Árstop arculati kézikönyv https://cdn.kormany.hu/uploads/sheets/7/7d/7d0/7d0fab19bd32412eabed6aa79f9ac16.pdf -->
    <div :class="$style.content">
      <template v-if="content && content.textWithList">
        <div v-for="(textWithList, index) in content.textWithList.items" :key="index" :class="$style.center">
          <div :class="$style.imageWrapper">
            <img
              :src="$addWebpPostfixIfSupported({ url: priceStop, webpUrl: priceStopWebp })"
              :alt="$awt('aw.cms.price_stop.logo')"
              loading="lazy"
              :class="$style.image"
            >
          </div>
          <lv-cms :class="$style.text" :content="textWithList.text" version2 />
          <ul :class="$style.list">
            <li v-for="item in textWithList.list" :key="item" :class="$style.listItem">
              {{ item }}
            </li>
          </ul>
        </div>
      </template>
      <div :class="$style.bottomText">
        <div>
          {{ $awt('aw.cms.price_stop.more_information') }}
        </div>
        <a v-bind="$hyperlinkComputeBindFromUrl($awt('aw.cms.price_stop.link.url'))" :class="$style.link" v-on="bannerEvtListeners">
          {{ $awt('aw.cms.price_stop.link.text') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import priceStop from '~~/common/assets/images/price-stop.png';
  import priceStopWebp from '~~/common/assets/images/price-stop.png.webp';
  import { LvCms } from '~~/common/components/loginet-vue-shop/index.mjs';
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin.js';

  export default {
    name: 'AwPriceStop',
    components: { LvCms },
    mixins: [analyticsBannerInteractionMixin],
    props: {
      content: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        priceStop,
        priceStopWebp,
      };
    },
    computed: {
      bannerEvtListeners () {
        return this.genBannerInteractionClickEventHandlers({ title: this.content.title });
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.wrapper {
  $color-goverment-primary: #004A8C;
  $color-goverment-secondary: #E4A34A;
  font-family: $secondary-font;
  font-weight: 500;
  padding: 24px 16px 32px;
  color: white;
  border-radius: 24px;
  background: $color-goverment-primary;
  @include tablet(min) {
    padding: 40px;
  }

  .content {
    position: relative;
    padding: 23px;
    border: 1px dashed #FFFFFF;
    border-radius: 16px;
  }

  .center {
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: auto;
    grid-template-rows: auto auto auto;
    gap: 24px;

    @include tablet(min) {
      grid-template-rows: auto;
      grid-template-columns: 86px 1fr 1fr;
      justify-content: space-between;
    }

    .list {
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 0 24px;
      padding: 0;
      text-align: center;
      gap: 16px;

      @include desktop-medium(min) {
        height: 112px;

        &Item {
          width: auto !important;
          max-width: 220px;
        }
      }

      &Item {
        font-size: 12px;
        font-weight: $font-weight-bold-v2;
        line-height: 16px;
        position: relative;
        left: -5px;
        width: calc(100% + 6px);
        list-style: none;

        &::before {
          display: inline-block;
          width: 4px;
          height: 4px;
          margin-right: 5px;
          margin-bottom: 2px;
          content: "";
          transform: rotate(45deg);
          background-color: $color-goverment-secondary;
        }

        &::after {
          position: absolute;
          bottom: -8px;
          left: calc(50% - 24px);
          display: inline-block;
          width: 48px;
          height: 1px;
          margin-right: 5px;
          margin-bottom: 2px;
          content: "";
          background-color: rgba($color-white, 0.2);
        }

        &:last-child::after {
          display: none;
        }

      }
    }

    .text {
      text-align: center;

      h1 {
        font-size: 16px;
        font-weight: $font-weight-bold-v2;
        line-height: 20px;
        margin-bottom: 8px;
      }

      p {
        font-size: 10px;
        font-weight: $font-weight-normal-v2;
        line-height: 16px;

        @include tablet(min) {
          font-size: 12px;
          line-height: 16px;
        }
      }

      @include tablet(min) {
        text-align: left;
      }
    }
  }

  .imageWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    .image {
      width: 86px;
      height: 86px;
    }
  }

  .bottomText {
    font-size: 12px;
    font-weight: 500;
    position: absolute;
    bottom: -25px;
    left: calc(50% - 75px);
    width: 150px;
    height: 50px;
    text-align: center;
    background-color: $color-goverment-primary;

    .link {
      color: $color-goverment-secondary;

      &:hover {
        color: $color-white;
      }
    }
  }
}
</style>
